module.exports = __webpack_public_path__ + "static/media/default-logo.6c4e35e0.jpg";